window.Products.Stationery.StationeryCard = function() {};
window.Products.Stationery.StationeryCard.inherits(window.Products.Stationery.Stationery);
window.Products.Stationery.StationeryCard.id = 69;
window.Products.Stationery.StationeryCard.slug = 'stationery-card';
window.Products.Stationery.StationeryCard.has_3d = true;
window.Products.Stationery.StationeryCard.use_variants = true;
window.Products.Stationery.StationeryCard.dpi = 300;

window.Products.Stationery.StationeryCard.prototype.set3dProperties = function(modelViewer) {
	modelViewer.scene.children[0].intensity = 0.96;
	modelViewer.scene.children[1].intensity = 0.12;

	modelViewer.object.position.y = 0.06;

	yRotation = new THREE.Matrix4();
	yRotation.makeRotationAxis(new THREE.Vector3(0, 1, 0).normalize(), 180 * Math.PI / 180);
	yRotation.multiply(modelViewer.object.matrix);
	modelViewer.object.matrix = yRotation;
	modelViewer.object.rotation.setFromRotationMatrix(modelViewer.object.matrix);

	this.updateThreeTexture(modelViewer);
};

window.Products.Stationery.StationeryCard.prototype.setThreeControls = function(controls) {
	controls.minDistance = 1.7;
	controls.maxDistance = 2.4;
};

window.Products.Stationery.StationeryCard.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[0].material[0].map = modelViewer.texture;
	modelViewer.object.children[0].material[0].bumpScale = 0.01;
	modelViewer.object.children[0].material[1].bumpScale = 0.01;
};